import styles from "./Modal.module.scss";
import cross from "../../../assets/svg/cross.svg";
import { useEffect } from "react";
import { testIds } from "../../../common/testData";

const Modal = ({
  open,
  handleClose,
  children,
  height,
  width,
  minHeight,
  showClose = true,
  zIndex,
  variant
}) => {
  let getStyles = () => {
    return {
      ...(height && { height: height }),
      ...(width && { width: width }),
      ...(minHeight && { minHeight: minHeight }),
      ...(zIndex && { zIndex })
    };
  };
  if (open) {
    window.scrollTo(0, 0);
    document.querySelector("body").style.overflow = "hidden";
  } else {
    document.querySelector("body").style.overflow = "auto";
  }

  useEffect(() => {
    return () => {
      document.querySelector("body").style.overflow = "auto";
    };
  }, []);
  return (
    <>
      {open && (
        <>
          <div className={styles["backdrop"]} style={{ ...(zIndex && { zIndex }) }}></div>
          <div className={`${styles["modal"]} ${styles[variant]}`} style={getStyles()}>
            <div className={styles["body"]}>
              {showClose && (
                <div
                  data-testid={testIds["modal-link"]}
                  className={`${styles["close"]} closeModalBtn`}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <img
                    src={cross}
                    height="10px"
                    width="10px"
                    alt="cross_icon"
                  />
                </div>
              )}
              {children}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Modal;
